module.exports = __webpack_public_path__ + "img/default.bbfa0f59.jpg";